import EdtSurveillancePage from '../../pages/EdtSurveillance';
import { SurveillantLayout } from '../SurveillantLayout';

export default function EdtWrapper() {
  return (
    <SurveillantLayout title="Emploi du temps" fullWidth>
      <EdtSurveillancePage />
    </SurveillantLayout>
  );
}
